import React, { useRef } from "react";
import "./Contact.css";
import { MdOutlineEmail } from "react-icons/md";
import { RiMessengerLine } from "react-icons/ri";
import { BsWhatsapp } from "react-icons/bs";
import emailjs from "emailjs-com";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm("service_rxu95n1", "template_zc5aeda", form.current, "5vAVtCOkfAbxNZlhe");
    alert("Your Message has been sent");
    e.target.reset();
  };

  return (
    <section id="contact">
      <h5>Get in Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className="contact__option-icon mx-auto" />
            <h4>Email</h4>
            <h5>baibhavkc11@gmail.com</h5>
            <a href="mailto:baibhavkc11@gmail.com" target="_blank" rel="noreferrer">
              Send a message
            </a>
          </article>
          <article className="contact__option">
            <RiMessengerLine className="contact__option-icon mx-auto" />
            <h4>Messenger</h4>
            <h5>baibhavkc</h5>
            <a href="https://m.me/Madridista.King07" target="_blank" rel="noreferrer">
              Send a message
            </a>
          </article>
          <article className="contact__option">
            <BsWhatsapp className="contact__option-icon mx-auto" />
            <h4>WhatsApp</h4>
            <h5>+9779860852534</h5>
            <a href="https://api.whatsapp.com/send?phone=9779860852534" target="_blank" rel="noreferrer">
              Send a message
            </a>
          </article>
        </div>
        <form ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            name="name"
            className="formInput"
            placeholder="Your Full Name"
            required
          />
          <input
            type="email"
            className="formInput"
            name="email"
            placeholder="Your Email"
            required
          />
          <textarea
            name="message"
            className="formInput"
            rows="7"
            placeholder="Your Message"
            required
          ></textarea>
          <button type="submit" className="btn btn-primary">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
